<template lang="pug">
    .page.unsubscribe
        .head.container
            calendar-title.black.small
        .content.container
            .container
                h2 ОТПИСКА ОТ НОВОСТНОЙ РАССЫЛКИ

            transition(name="fade" mode="out-in")

                .container(v-if="success" key="1")
                    p Спасибо, настройки вашей подписки изменены.
                    br
                    p.bold Ваш Email: {{email}}
                    br
                    .app_btn.red(@click="success=false") ВЕРНУТЬСЯ К НАСТРОЙКАМ

                .container(v-else-if="loaded && !subscribes.length" key="2")
                    p Актуальных подписок на события нет.
                    br
                    p.bold Ваш Email: {{email}}

                .container(v-else-if="loaded" key="3")
                    p Вы уверены, что хотите отписаться и не получать больше уведомления,<br> которые доступны только подписчикам?
                    br
                    p.bold Ваш Email: {{email}}
                    br
                    br
                    p Ваши актуальные подписки:
                    br
                    .app_checkbox(v-for="subscribe in subscribes")
                        input(type="checkbox" :id="subscribe.ID")
                        label(:for="subscribe.ID" @click="subscribe.isActive^=1")
                            .square(:class="{active:subscribe.isActive}")
                            span {{subscribe.NAME}}
                    h5 Вы уверены, что хотите отписаться от новостей?
                    .app_checkbox
                        input#unsubscribeAll(type="checkbox" v-model="unsubscribeAll")
                        label(for="unsubscribeAll")
                            .square(:class="{active:unsubscribeAll}")
                            span Отписаться от всех обновлений
                    .app_btn.red(@click="submit") Отписаться

                preloader(v-else  key="4")

        parallax-figures_home
</template>

<script>
    import CalendarTitle from "../components/other/CalendarTitle";
    import ParallaxFigures_home from "../components/other/ParallaxFigures_home";
    import Preloader from "../components/other/Preloader";
    export default {
        name: "Unsubscribe",
        data:()=>({
            subscribes: [],
            id: null,
            confirm_code: null,
            unsubscribeAll: false,
            email: null,

            loaded: false,
            success: false,
        }),
        created(){
            if (this.$route.query.ID){
                this.id = this.$route.query.ID;
                this.confirm_code = this.$route.query.CONFIRM_CODE;
                this.getSubscribes();
            }else{
                this.$router.replace('/')
            }
        },
        methods:{
            async getSubscribes(){
                try {
                    let {data} = await this.axios.get(`?ACTION=getSubscribe&ID=${this.id}&CONFIRM_CODE=${this.confirm_code}`);
                    if (data.STATUS === 'ok') {
                        this.email = data.DATA.EMAIL;
                        this.subscribes = data.DATA.RUBRIC_LIST.map(el=>({...el, isActive: true}));
                        setTimeout(()=>{
                            this.loaded = true;
                        }, 500)
                    }
                } catch (e) {
                    console.log(e);
                }
            },
            async submit(){
                let fd = new FormData;
                fd.append('ID', this.id);
                fd.append('CONFIRM_CODE', this.confirm_code);
                let subscribes = this.unsubscribeAll ? [] : this.subscribes.filter(s=>s.isActive).map(s=>s.ID);
                subscribes.forEach((s, ind)=>{
                    fd.append('RUB_ID['+ind+']', s);
                });

                let {data} = await this.axios.post('?ACTION=updateSubscribe', fd);
                if(data.STATUS === 'ok'){
                    if (this.unsubscribeAll) {
                        this.unsubscribeAll = false;
                        this.subscribes = [];
                    }else{
                        this.subscribes = this.subscribes.filter(s=>s.isActive);
                    }
                    this.success = true;
                }
            }
        },
        components: {Preloader, ParallaxFigures_home, CalendarTitle}
    }
</script>

<style scoped lang="scss">
    .unsubscribe{
        min-height: 100vh;
        padding-bottom: 5rem;
        background: #fff;
    }
    .head{
        max-width: 92rem;
        margin-bottom: 0.4rem;
        padding-top: 1.3rem;
    }
    .content{
        position: relative;
        line-height: 1.44;
        color: #000;
        .container{
            max-width: 73.5rem;
        }
        h2{
            margin-bottom: 0.6rem;
            font-size: 2.5rem;
            font-weight: bold;
            letter-spacing: -0.02rem;
            color: $red;
        }
        p{
            font-family: Arial;
            font-size: to_rem(15px);
            line-height: 1.2;
        }
        h5{
            margin: 4rem 0 1.2rem;
            font-family: Arial;
            font-size: to_rem(19px);
        }
    }
    .preloader{
        position: absolute;
        left: 50%;
        top: 0;
        transform: translateX(-50%);
    }
    .app_checkbox{
        margin-bottom: 0.84rem;
        .square{
            margin-top: 0;
            border-color: #c7cccf;
            &.active{
                border-color: $red;
            }
        }
        label{
            font-size: to_rem(15px);
            span{
                opacity: 1;
                color: #000;
            }
        }
    }
    .app_btn{
        justify-content: center;
        width: 20rem;
        margin-top: 0.9rem;
        padding: 0.2rem 0 0.1rem;
        font-size: 1.52rem;
    }
</style>
